import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

let app = null;
let auth = null;
let db = null;
let googleProvider = null;
let functions = null;
let firebaseInitError = null;

let appId = 'default-app-id';

try {
  const rawConfig = process.env.REACT_APP_FIREBASE_CONFIG;

  if (!rawConfig) {
    throw new Error(
      'La variable de entorno REACT_APP_FIREBASE_CONFIG no está definida. ' +
      'Asegúrate de tener un archivo .env en la raíz del proyecto y de haber reiniciado el servidor.'
    );
  }

  const firebaseConfig = JSON.parse(rawConfig);

  if (!firebaseConfig.apiKey) {
    throw new Error('Falta apiKey en REACT_APP_FIREBASE_CONFIG');
  }

  if (!firebaseConfig.authDomain) {
    throw new Error('Falta authDomain en REACT_APP_FIREBASE_CONFIG');
  }

  if (!firebaseConfig.projectId) {
    throw new Error('Falta projectId en REACT_APP_FIREBASE_CONFIG');
  }

  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  functions = getFunctions(app, 'us-central1');
  googleProvider = new GoogleAuthProvider();

  appId =
    process.env.REACT_APP_ARTIFACTS_NAMESPACE ||
    firebaseConfig.measurementId ||
    firebaseConfig.appId ||
    'default-app-id';

  console.log('Firebase projectId:', firebaseConfig.projectId);
  console.log('Firebase authDomain:', firebaseConfig.authDomain);
  console.log('Firebase real appId:', firebaseConfig.appId || '(sin appId)');
  console.log('Firebase measurementId:', firebaseConfig.measurementId || '(sin measurementId)');
  console.log('Namespace usado por la app (appId):', appId);
} catch (error) {
  console.error('Error al inicializar Firebase:', error);
  firebaseInitError = error.message || 'Error desconocido al inicializar Firebase';
}

export { app, auth, db, functions, googleProvider, firebaseInitError, appId };
